'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const transitionFadeInFromBottom = (options)=>{
    const { transitionDelay , transitionDuration , transitionStatus  } = options;
    switch(transitionStatus){
        case 'entered':
            {
                return {
                    opacity: 1,
                    bottom: 0
                };
            }
        case 'entering':
            {
                return {
                    opacity: 1,
                    bottom: 0,
                    transition: `opacity ${transitionDuration}ms ease-in ${transitionDelay}ms, bottom ${transitionDuration}ms ease-in ${transitionDelay}ms`
                };
            }
        case 'exited':
            {
                return {
                    opacity: 0,
                    bottom: '-100%'
                };
            }
        case 'exiting':
            {
                return {
                    opacity: 0,
                    transition: `opacity ${transitionDuration}ms ease-in ${transitionDelay}ms, bottom ${transitionDuration}ms ease-in ${transitionDelay}ms`,
                    bottom: '-100%'
                };
            }
        default:
            {
                // unmounted
                return {
                    opacity: 0,
                    bottom: '-100%'
                };
            }
    }
};

exports.transitionFadeInFromBottom = transitionFadeInFromBottom;
//# sourceMappingURL=fade-in-from-bottom.js.map
